export * from './env';
export * from './universe';
export * from './users';
export * from './trainingTypes';
export * from './trainingAccentColors';
export * from './staging';
export * from './sina/progress';

export const getVersion = () => window.__VERSION;
